import axios from "axios";

export const STRIPE_CREDIT_PAYMENT_LINK = "https://buy.stripe.com/4gMbJ17wBc1d0in02w2wU0a";

export function buildStripeCreditPurchaseUrl(verifiedEmail) {
  const normalizedEmail = typeof verifiedEmail === "string" ? verifiedEmail.trim() : "";
  if (!normalizedEmail) return "";
  const url = new URL(STRIPE_CREDIT_PAYMENT_LINK);
  url.searchParams.set("locked_prefilled_email", normalizedEmail);
  return url.toString();
}

export const PUBLIC_SESSION_CONFIG = {
  withCredentials: true,
  credentials: "include",
};

export function getPublicSession() {
  return axios.get("/api/public/account/session", PUBLIC_SESSION_CONFIG);
}

export function logoutPublicSession() {
  return axios.post("/api/public/account/logout", {}, PUBLIC_SESSION_CONFIG);
}

export function getPublicSessionPayload(response) {
  const payload = response?.data?.data || response?.data || {};
  return {
    authenticated: payload.authenticated === true,
    user: payload.user || null,
    balances: payload.balances || null,
    practice_simulator_assessment_enabled: payload.practice_simulator_assessment_enabled === true,
  };
}

export function isPublicSessionError(error) {
  if (error?.response?.status === 402) return false;
  const data = error?.response?.data?.data || error?.response?.data || {};
  const code = data.error_code || data.error || data.code || data.reason || "";
  return error?.response?.status === 401 || [
    "public_session_required",
    "missing_public_session",
    "invalid_public_session",
    "public_session_expired",
  ].includes(code);
}
